export const getTicketViewer = (state) => {
  return state.ticketViewer;
};

export const getTicketId = (state) => {
  const { ticketId } = getTicketViewer(state);
  return ticketId;
};

export const getJobId = (state) => {
  const { jobId } = getTicketViewer(state);
  return jobId;
};
